import React from 'react';
import { ReactComponent as TriangleAdmiration } from '../../assets/icons/TriangleAdmiration.svg';
import classes from './ErrorBoundary.module.scss';

// Componente funcional para mostrar el error
const ErrorContent = ({ error, onRetry }) => {

  const getErrorMessage = () => {
    // Mensajes amigables según el tipo de error
    if (error && error.message) {
      if (error.message.includes('404') || error.message.includes('Not Found')) {
        return {
          title: 'Página no encontrada',
          message: 'La página que buscas no existe o ha sido movida.'
        };
      }
      
      if (error.message.includes('403') || error.message.includes('Forbidden')) {
        return {
          title: 'Acceso denegado',
          message: 'No tienes permisos para acceder a esta página.'
        };
      }
      
      if (error.message.includes('500') || error.message.includes('Internal Server Error')) {
        return {
          title: 'Error del servidor',
          message: 'Nuestros servidores están experimentando problemas. Inténtalo más tarde.'
        };
      }
      
      if (error.message.includes('Network') || error.message.includes('fetch')) {
        return {
          title: 'Problema de conexión',
          message: 'Verifica tu conexión a internet e inténtalo nuevamente.'
        };
      }
      
      if (error.message.includes('apiEndpoints') || error.message.includes('apiMethods')) {
        return {
          title: 'Error de configuración',
          message: 'Hay un problema con la configuración de la aplicación. Recarga la página.'
        };
      }
    }
    
    // Mensaje por defecto
    return {
      title: 'Algo salió mal',
      message: 'La aplicación encontró un error inesperado. Esto puede ser temporal.'
    };
  };


  const { title, message } = getErrorMessage();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <TriangleAdmiration className={classes.icon} />
        <h1 className={classes.title}>{title}</h1>
        <p className={classes.message}>{message}</p>
        
      </div>
    </div>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el state para mostrar la UI de error
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Solo registrar en consola en desarrollo, sin mostrar al usuario
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorContent error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
